jQuery(document).ready(function() {
  function applyImageExpand() {
    // Check if window width is greater than 1024px
    if (jQuery(window).width() > 1024) {
      var imgs = jQuery('.img-expand');
      var centerIdx = Math.floor(imgs.length / 2);

      // Set default widths
      imgs.css('width', '20%');
      imgs.eq(centerIdx).css('width', '60%');

      // Unbind previous events to prevent multiple bindings
      imgs.off('mouseover mouseout');

      // Mouseover event
      imgs.mouseover(function() {
        imgs.stop().animate({ width: '20%' }, 300);
        jQuery(this).stop().animate({ width: '60%' }, 300);
      });

      // Mouseout event
      imgs.mouseout(function() {
        imgs.stop().animate({ width: '20%' }, 300);
        imgs.eq(centerIdx).stop().animate({ width: '60%' }, 300);
      });
    } else {
      // Reset styles for smaller screens
      jQuery('.img-expand').css('width', ''); // Remove inline width styles
      jQuery('.img-expand').off('mouseover mouseout'); // Remove event listeners
    }
  }

  // Run on page load
  applyImageExpand();

  // Run on window resize
  jQuery(window).resize(function() {
    applyImageExpand();
  });
});